import { AppContext } from 'providers/AppContext';
import { useContext, useState } from 'react';
import useSWR from 'swr';
import type { CompletionMetricsResponse, CompletionWindowType } from 'types';

export type CompletionMetricsHook = ReturnType<typeof useCompletionMetrics>;

export function useCompletionMetrics() {
	const ctx = useContext(AppContext);
	const [windowType, setWindowType] = useState<CompletionWindowType>('AllTime');
	// includeMonthlyTraffic=true is required — otherwise monthlyTraffic comes back empty.
	const url = `${ctx.config.API.completionMetrics}?windowType=${windowType}&includeMonthlyTraffic=true`;
	const { data, error, isLoading } = useSWR<CompletionMetricsResponse>(url);

	return {
		error,
		isLoading,
		separators: {
			decimalSeparator: ctx.state.language.decimalSeparator,
			thousandSeparator: ctx.state.language.thousandSeparator
		},
		monthlyTraffic: data?.monthlyTraffic ?? [],
		setWindowType,
		summary: data?.summary,
		t: ctx.t,
		windowType
	};
}
